import React, {useState} from "react";
import {Col, FormGroup, Input, Row} from "reactstrap";
import {every, isEmpty} from "lodash";
import {toast} from "react-toastify";

// import PropTypes from "prop-types";

const INITIAL_LOCAL_STATE = {
  user: {
    first_name: "",
    last_name: "",
    username: "",
    email: "",
  },
};

const MANDATORY_KEYS = ["first_name", "last_name", "email", "username"];

function UserInformation(_props, ref) {
  const [userInfoObject, setUserInfoObject] = useState(INITIAL_LOCAL_STATE);
  const [submitted, setSubmitted] = useState(false);

  const checkForValidation = () => {
    const validated = every(MANDATORY_KEYS, (each) => !!userInfoObject.user[each]);
    setSubmitted(true);
    if (!validated) {
      toast.error("Please check required fields");
    }
    return validated;
  };

  /* ## This Imperative Handle and customizes the instance value that is exposed to parent components when using ref. Please Don't Remove this Line ## */
  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return checkForValidation();
    },
    state: userInfoObject,
  }));

  const onChangeHandler = (e) => {
    const {value, name} = e.target;
    setUserInfoObject({
      user: Object.assign({}, userInfoObject.user, {
        [name]: value,
      }),
    });
  };

  const {first_name, last_name, username, email} = userInfoObject.user;

  return (
    <div className="pl-lg-4">
      <Row>
        <Col lg="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="first-name">
              First Name <span className="text-red">*</span>
            </label>
            <Input
              className="form-control-alternative"
              id="first-name"
              placeholder="First Name"
              type="text"
              name="first_name"
              data-cy={"first_name"}
              invalid={isEmpty(first_name) && submitted}
              value={first_name}
              onChange={onChangeHandler}
            />
          </FormGroup>
        </Col>
        <Col lg="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="last-name">
              Last Name <span className="text-red">*</span>
            </label>
            <Input
              className="form-control-alternative"
              // defaultValue="United States"
              id="last-name"
              placeholder="Last Name"
              type="text"
              name="last_name"
              data-cy={"last_name"}
              invalid={isEmpty(last_name) && submitted}
              value={last_name}
              onChange={onChangeHandler}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <FormGroup>
            <label className="form-control-label" htmlFor="username">
              Username <span className="text-red">*</span>
            </label>
            <Input
              className="form-control-alternative"
              id="username"
              placeholder="Username"
              type="text"
              name="username"
              data-cy={"username"}
              invalid={isEmpty(username) && submitted}
              value={username}
              onChange={onChangeHandler}
            />
          </FormGroup>
        </Col>
        <Col md="12">
          <FormGroup>
            <label className="form-control-label" htmlFor="email">
              Email <span className="text-red">*</span>
            </label>
            <Input
              className="form-control-alternative"
              // defaultValue="Bld Mihail Kogalniceanu, nr. 8 Bl 1, Sc 1, Ap 09"
              id="email"
              placeholder="Email"
              type="text"
              name="email"
              data-cy={"email"}
              invalid={isEmpty(email) && submitted}
              value={email}
              onChange={onChangeHandler}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
}

UserInformation.propTypes = {};
export default React.forwardRef(UserInformation);
